<template>
  <v-select
    :items="expensesTypesList"
    item-value="id"
    item-text="expenseTypeName"
    v-model="expenseTypeIdValue"
    label="Expense Type"
    :clearable="clearable ? clearable : false"
    :rules="[requiredCheck()]"
    outlined
  ></v-select>
</template>

<script>
import { required } from '@/lib/formValidations'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'

export default {
  props: [
    'expenseTypeId',
    'isRequired',
    'clearable'
  ],
  computed: {
    ...mapFields('expensesTypes',
      ['expensesTypesList']),
    expenseTypeIdValue: {
      get () {
        return this.expenseTypeId
      },
      set (newExpenseTypeId) {
        this.$emit('expenseTypeIdChange', newExpenseTypeId)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required('Expense Type')
    },
    ...mapActions('expensesTypes',
      ['getExpensesTypes'])
  },
  created () {
    this.getExpensesTypes()
  }
}
</script>
